import {Component, model, Optional} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MatDialogRef} from '@angular/material/dialog';
import {ReconciliationFileService} from '../../service/reconciliation-file.service';

@Component({
    selector: 'reconciliation-upload-modal',
    templateUrl: './reconciliation-upload-modal.component.html',
    standalone: false
})
export class ReconciliationUploadModalComponent {
    public readonly acceptFiles = model(['.xlsx']);

    public readonly handleUpload = model(false);

    isLoading = false;

    reconciliationForm!:FormGroup;

    ccProcessors = model([
        {
            id: 1,
            displayName: 'Connexpay',
        },
        {
            id: 2,
            displayName: 'Braintree',
        }
    ]);

    constructor(
        @Optional() public reonciliationUploadDialogRef: MatDialogRef<ReconciliationUploadModalComponent>,
        private formBuilder: FormBuilder,
        private reconFileService: ReconciliationFileService,
    ){

        this.reconciliationForm = this.formBuilder.group({
            ccProcessorId: [null, Validators.required],
            file: [null, Validators.required],
        });
    }

    formCloseEvent(sentFile?: boolean): void {
        if (this.reonciliationUploadDialogRef) {
          this.reonciliationUploadDialogRef.close(sentFile);
        }
    }

    onFileChange(event: any) {
        const file = event?.target?.files[0];
        if(file) {
            this.reconciliationForm.controls['file'].patchValue({file});
        } else {
            this.reconciliationForm.controls['file'].reset();
        }

   }

    sendFile() : void {
        if(this.handleUpload()) 
            return this.reonciliationUploadDialogRef.close(this.reconciliationForm.value);

        this.isLoading = true;
        this.reconFileService.sendFileContent(this.reconciliationForm.value).subscribe({
            next: ()=>{
                this.formCloseEvent(true);
            },
            error: ()=>{
                this.isLoading = false
                this.formCloseEvent(false);
            }
        });

    }

    clearFields(...args:string[]): void {
        if(!args.length) {
            this.reconciliationForm.reset();
            return;
        }
        args.forEach((field)=>{
            this.reconciliationForm.controls[field].reset()
        })
    }
}